/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF Delivery API
 * OpenAPI spec version: 1.0
 */

export type ContactPageContentModelContentType = typeof ContactPageContentModelContentType[keyof typeof ContactPageContentModelContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactPageContentModelContentType = {
  contactPage: 'contactPage',
} as const;
